import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './SubscriptionStyles.css'; // Reuse or create specific styles

// Helper function to parse query string (can be moved to a utils file)
const parseQueryString = (queryString) => {
    const params = {};
    const query = queryString.substring(1); // Remove leading '?'
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');
        const key = decodeURIComponent(pair[0]);
        const value = decodeURIComponent(pair[1] || '');
        params[key] = value;
    }
    return params;
};

const PaymentFailurePage = () => {
    const location = useLocation();
    const queryParams = parseQueryString(location.search);
    const orderNumber = queryParams.order_number; // Get order number if available
    // Monri might not always return details on failure/cancel, handle gracefully

    return (
        <div className="payment-result-container failure">
            <h2>Status plaćanja</h2>
            <div className="error-content">
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="error-icon">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="15" y1="9" x2="9" y2="15"></line>
                    <line x1="9" y1="9" x2="15" y2="15"></line>
                </svg>
                <h3>Plaćanje neuspješno ili otkazano</h3>
                <p>Vaša transakcija nije uspješno obrađena ili ste je otkazali.</p>
                {orderNumber && (
                    <p><strong>Broj narudžbe:</strong> {orderNumber}</p>
                )}
                <p>Molimo pokušajte ponovo ili odaberite drugi način plaćanja.</p>
                <p>Ako ste sigurni da je došlo do greške, molimo kontaktirajte podršku.</p>
                
                <div className="button-group">
                    <Link to="/app/subscribe" className="button-link">
                        Pokušaj ponovo
                    </Link>
                    <Link to="/app/chat" className="button-link secondary">
                        Povratak na Chat
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default PaymentFailurePage;

